
import { computed, defineComponent } from 'vue'

export default defineComponent({
    name: 'new-pagination',
    props: {
        currentPage: {
            type: Number,
            default: 1,
        },
        totalPages: {
            type: Number,
            default: 1,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['change-page'],
    setup(props, { emit }) {
        const isPrevDisabled = computed(() => {
            if (props.currentPage <= 1 || props.disabled) {
                return true
            }

            return false
        })

        const isNextDisabled = computed(() => {
            if (props.currentPage >= props.totalPages || props.disabled) {
                return true
            }

            return false
        })

        const onPrev = () => {
            if (props.disabled || isPrevDisabled.value) return
            emit('change-page', props.currentPage - 1)
        }

        const onNext = () => {
            if (props.disabled || isNextDisabled.value) return
            emit('change-page', props.currentPage + 1)
        }

        const onFirst = () => {
            if (props.disabled || isPrevDisabled.value) return
            emit('change-page', 1)
        }

        const onLast = () => {
            if (props.disabled || isNextDisabled.value) return
            emit('change-page', props.totalPages)
        }

        return {
            isPrevDisabled,
            isNextDisabled,
            onPrev,
            onNext,
            onFirst,
            onLast,
        }
    },
})
